<template>
<div class="shadow-box">
  <div class="h3-title flex-row flex-main-axis-between" style="margin-top: 0;">
    <span>用户角色管理</span>
    <el-button type="primary" icon="el-icon-plus" @click="openAddDialog">新增用户角色</el-button>
  </div>
  <div class="page-main_box">
    <!-- 筛选区 -->
    <div class="flex-row search-box">
      <div class="search-item">
        <el-select
          v-model="form.roleType"
          clearable
          filterable
          placeholder="角色筛选"
          style="width: 180px;">
          <el-option
            v-for="item in roleOptions"
            :key="item.roleType"
            :value="item.roleType"
            :label="item.roleName">
          </el-option>
        </el-select>
      </div>
      <div class="search-item">
        <el-input
          v-model="form.keyword"
          clearable
          placeholder="昵称 / 手机号"
          style="width: 200px;"
          @keyup.enter.native="search">
        </el-input>
      </div>
      <el-button type="primary" @click="search">查询</el-button>
      <el-button @click="reset">重置</el-button>
    </div>

    <!-- 用户列表 -->
    <el-table
      :data="tableData"
      v-loading="isLoading"
      border
      stripe
      style="width: 100%;"
      height="calc(100vh - 290px)">
      <el-table-column prop="userId" label="用户ID" min-width="190"></el-table-column>
      <el-table-column prop="nickName" label="昵称" min-width="120"></el-table-column>
      <el-table-column prop="mobilePhone" label="手机号" min-width="130"></el-table-column>
      <el-table-column prop="roleName" label="角色" min-width="130"></el-table-column>
      <el-table-column label="角色状态" min-width="100">
        <template slot-scope="{ row }">
          <el-tag :type="row.available ? 'success' : 'info'" size="mini">
            {{ row.available ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="150">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openAssignDialog(row)">改角色</el-button>
          <el-button type="text" style="color: #f56c6c;" @click="confirmRemove(row)">移除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div style="margin-top: 12px;">
      <el-pagination
        class="d-ib"
        background
        layout="total, prev, pager, next, jumper"
        :total="pageInfo.total"
        :page-size="pageInfo.size"
        :current-page="pageInfo.current"
        @current-change="onPageChange">
      </el-pagination>
    </div>
  </div>

  <!-- 改角色弹窗 -->
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="showAssignDialog"
    title="修改角色"
    width="420px">
    <div style="margin-bottom: 12px; color: #666;" v-if="currentRow">
      用户:{{ currentRow.nickName || '-' }}({{ currentRow.mobilePhone || '-' }})
    </div>
    <el-select
      v-model="assignForm.roleType"
      filterable
      placeholder="请选择角色"
      style="width: 100%;">
      <el-option
        v-for="item in roleOptions"
        :key="item.roleType"
        :value="item.roleType"
        :label="item.roleName">
      </el-option>
    </el-select>
    <div slot="footer">
      <el-button @click="showAssignDialog = false">取消</el-button>
      <el-button type="primary" :loading="submitting" @click="submitAssign">保存</el-button>
    </div>
  </el-dialog>

  <!-- 新增用户角色弹窗 -->
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="showAddDialog"
    title="新增用户角色"
    width="420px">
    <el-form label-width="72px">
      <el-form-item label="用户ID" required>
        <el-input v-model="addForm.userId" clearable placeholder="请输入用户ID(18位字符串)"></el-input>
      </el-form-item>
      <el-form-item label="角色" required>
        <el-select v-model="addForm.roleType" filterable placeholder="请选择角色" style="width: 100%;">
          <el-option
            v-for="item in roleOptions"
            :key="item.roleType"
            :value="item.roleType"
            :label="item.roleName">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="showAddDialog = false">取消</el-button>
      <el-button type="primary" :loading="addSubmitting" @click="submitAdd">保存</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import { roleList, userPage, userAssignRole, userRemoveRole } from '@/service/apis/bdAdminRole'
import { getRoletype } from '@/utils/getUser'

export default {
  name: 'system-user-role',
  computed: {
    roleType () {
      return getRoletype()
    }
  },
  data () {
    return {
      form: {
        roleType: '',
        keyword: ''
      },
      roleOptions: [],
      tableData: [],
      isLoading: false,
      pageInfo: {
        current: 1,
        size: 10,
        total: 0
      },
      showAssignDialog: false,
      submitting: false,
      currentRow: null,
      assignForm: {
        roleType: ''
      },
      showAddDialog: false,
      addSubmitting: false,
      addForm: {
        userId: '',
        roleType: ''
      }
    }
  },
  created () {
    this.getRoleOptions()
    this.getList()
  },
  methods: {
    // 角色下拉(只列可用角色;指派角色时禁用角色不可选)
    getRoleOptions () {
      roleList.call(this).then(res => {
        this.roleOptions = (res || []).filter(r => r.available)
      })
    },
    getList () {
      this.isLoading = true
      const params = {
        pageIndex: this.pageInfo.current,
        pageSize: this.pageInfo.size
      }
      if (this.form.roleType) params.roleType = this.form.roleType
      if (this.form.keyword) params.keyword = this.form.keyword
      userPage.call(this, params).then(res => {
        const data = res || {}
        this.tableData = data.records || []
        this.pageInfo.total = data.total || 0
      }).finally(() => {
        this.isLoading = false
      })
    },
    search () {
      this.pageInfo.current = 1
      this.getList()
    },
    reset () {
      this.form = { roleType: '', keyword: '' }
      this.search()
    },
    onPageChange (page) {
      this.pageInfo.current = page
      this.getList()
    },
    openAssignDialog (row) {
      this.currentRow = row
      this.assignForm.roleType = row.roleType
      this.showAssignDialog = true
    },
    submitAssign () {
      if (!this.assignForm.roleType) {
        this.$message.warning('请选择角色')
        return
      }
      this.submitting = true
      userAssignRole.call(this, {
        userId: this.currentRow.userId,
        roleType: this.assignForm.roleType
      }).then(() => {
        this.$message.success('修改成功')
        this.showAssignDialog = false
        this.getList()
      }).finally(() => {
        this.submitting = false
      })
    },
    confirmRemove (row) {
      this.$confirm(`确认移除「${row.nickName || row.mobilePhone || row.userId}」的角色吗?`, '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        userRemoveRole.call(this, row.userId).then(() => {
          this.$message.success('移除成功')
          this.getList()
        })
      }).catch(() => {})
    },
    openAddDialog () {
      this.addForm = { userId: '', roleType: '' }
      this.showAddDialog = true
    },
    submitAdd () {
      if (!this.addForm.userId) {
        this.$message.warning('请输入用户ID')
        return
      }
      if (!this.addForm.roleType) {
        this.$message.warning('请选择角色')
        return
      }
      this.addSubmitting = true
      userAssignRole.call(this, {
        userId: this.addForm.userId,
        roleType: this.addForm.roleType
      }).then(() => {
        this.$message.success('新增成功')
        this.showAddDialog = false
        this.getList()
      }).finally(() => {
        this.addSubmitting = false
      })
    }
  }
}
</script>
